module.exports = __webpack_public_path__ + "static/media/empty-gallery.045d3522.svg";